import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

export type SelectOption = {
  value: string;
  text: string;
};
export type SelectDictionaryProps = {
  getOptions: () => Promise<SelectOption[]> | SelectOption[];
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean; 
};
export function SelectDictionary(props: SelectDictionaryProps) {
  const [options, setOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    const r = props.getOptions();
    if (Array.isArray(r)) {
      setOptions(r);
    } else {
      r.then((r) => setOptions(r));
    }
  }, []);

  return (
    <Select onValueChange={props.onChange} value={props.value}>
      <SelectTrigger disabled={props.disabled}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.text}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
